export default __webpack_public_path__ + "static/media/gallery-wip-flash-suppressor_01.a989a59c.jpg";